import { Location } from 'history';

const ACTIVITIES_REGEX = /^.*\/app\/activities\/users\/([^/]+)\/.*$/i;
const CVI_REGEX = /^.*\/app\/import\/cv\/users\/([^/]+)\/.*$/i;

function getMatch(value: string, regex: RegExp) {
	const match = value.match(regex);
	return match ? match[1] : null;
}

export default function getLocationUserId(location: Location): string | null {
	const { pathname } = location;
	const activitiesMatch = getMatch(pathname, ACTIVITIES_REGEX);
	if (activitiesMatch) {
		return activitiesMatch;
	}
	return getMatch(pathname, CVI_REGEX);
}
